/**
 * 사용자 표시 이름(displayName)에서 아바타용 이니셜을 추출하는 유틸리티.
 * - 앞뒤 공백 제거 후 빈 값이면 '?' 반환
 * - 이모지 및 서러게이트 페어 보호를 위해 Array.from() 코드포인트 단위 분해
 * - 첫 글자가 CJK(한글, 한자, 히라가나, 가타카나)이면 1글자만 반환
 * - 그 외(로마자, 키릴 등)이면:
 *   · 공백 구분 단어가 2개 이상: 앞 2개 단어의 첫 글자 조합 (예: John Smith -> JS)
 *   · 단어가 1개: 앞 2글자 (예: puppynwhisker -> PU)
 *   · 대문자로 변환
 */

const CJK_REGEX = /^[\p{Script=Hangul}\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}]/u;

export function getInitials(name) {
  if (!name || typeof name !== 'string') {
    return '?';
  }

  const trimmed = name.trim();
  if (!trimmed) {
    return '?';
  }

  const chars = Array.from(trimmed);
  const firstChar = chars[0];

  // 1. 첫 글자가 CJK 문자군인 경우: 첫 1글자 반환
  if (CJK_REGEX.test(firstChar)) {
    return firstChar;
  }

  // 2. 그 외(로마자 등) 문자군인 경우
  const words = trimmed.split(/\s+/).filter(Boolean);

  if (words.length >= 2) {
    const firstInitial = Array.from(words[0])[0] || '';
    const secondInitial = Array.from(words[1])[0] || '';
    return (firstInitial + secondInitial).toUpperCase();
  }

  // 단어가 1개인 경우: 앞 2글자 추출
  const twoChars = chars.slice(0, 2).join('');
  return twoChars.toUpperCase();
}
